import React from 'react';
import AdminSpaceHeader from '../../common/AdminSpaceHeader/AdminSpaceHeader';

const Header: React.FC = () => {
  return <AdminSpaceHeader label="Add new model's metadata options" />;
};

export default Header;
